/** @jsxImportSource @emotion/react */
import React from 'react';
import type { Theme } from '@mui/material';
import type { Interpolation } from 'styled-components';
import type { ITheme, ThemeColor } from '../../styles/theme';
import { theme as defaultTheme } from '../../styles/theme';

interface IProps {
  color?: ThemeColor;
  theme?: ITheme;
}

const PlayIcon: React.FC<IProps> = ({ color, theme = defaultTheme }) => {
  const iconColor = color ?? theme.colors.grayscale.inactiveGrey1;

  const rootStyles: Interpolation<Theme> = {
    position: 'absolute',
    width: '48px',
    height: '48px',
    filter: 'drop-shadow(0px 3.09677px 3.09677px rgba(0, 0, 0, 0.25))',
  };

  const ellipsStyles: Interpolation<Theme> = {
    position: 'absolute',
    width: '48px',
    height: '48px',
    border: `3.87px solid ${iconColor}`,
    borderRadius: '50%',
  };

  const triangleStyles: Interpolation<Theme> = {
    position: 'absolute',
    left: '16px',
    top: '12px',
    borderTop: '12px solid transparent',
    borderLeft: `20px solid ${iconColor}`,
    borderBottom: '12px solid transparent',
  };

  return (
    <div css={rootStyles}>
      <div css={ellipsStyles} />
      <div css={triangleStyles} />
    </div>
  );
};

export default PlayIcon;
